import React, { useState } from "react";
import Input from "react-phone-number-input/input";

import { Box } from "@mui/material";

import "react-phone-number-input/style.css";
import "./ph.css";

interface NumberInputProps {
    id?: string;
    value: string | null;
    name?: string;
    label?: string;
    onChange: (value: string) => void;
    required?: boolean | null;
    error?: boolean;
    toolTip?: string;
    placeholder?: string;
    helperText?: string;
    defaultValue?: string;
    disabled?: boolean;
    onBlur?: any;
    errorText?: any;
    type?: string;
    sx?: any;
    readOnly?: any;
    rows?: any;
    regexPattern?: any;
}

const PhoneNumberInput: React.FC<NumberInputProps> = ({
    value,
    readOnly,
    onChange,
    placeholder,
    error,
    errorText,
    required,
    sx,
    onBlur,
    id,
    name
}: any) => {
    const [showError, setError] = useState<string | null>(null);

    const handleInputChange = (newValue: any) => {
        if (newValue?.length === 12) {
            setError(null);
        } else {
            setError("Please enter a valid 10-digit phone number.");
        }
        if (onChange) {
            onChange(newValue);
        }
    };
    const inputStyle = {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        height: "40px",
        fontSize: "17px",
        paddingLeft: "10px",
        border: `1px solid ${showError || error ? "#db2f2f" : sx ? "#433C4D" : "#CBC7C7"}`,
        borderRadius: "6px",
        fontFamily: "Poppins, sans-serif",
        backgroundColor: sx ? "#433C4D" : "",
        color: sx ? "white" : ""
    };
    const placeholderStyle = {
        color: sx ? "rgba(255, 255, 255, 0.3)" : "rgba(0, 0, 0, 0.3)" // Adjust opacity for the placeholder color
    };
    const onPaste = (event: any) => {
        const pastedText = (event?.clipboardData || window.Clipboard)?.getData("text");
        handleInputChange(pastedText);
    };

    return (
        <Box paddingY={1} display="flex" justifyContent="space-around" gap={2} alignItems="center" position="relative" height="auto">
            <Input
                country="US"
                onPaste={onPaste}
                value={value}
                // international
                // withCountryCallingCode
                className="custom-input"
                onChange={(inputValue) => handleInputChange(inputValue)}
                style={inputStyle}
                placeholder={placeholder}
                maxLength={14}
                helperText={error || showError ? errorText : ""}
                required={required}
                onBlur={onBlur}
                id={id}
                readOnly={readOnly}
                name={name}
                error={error}
                inputStyle={placeholderStyle}
            />
        </Box>
    );
};

export default PhoneNumberInput;
